module.exports = __webpack_public_path__ + "img/12_The passport has expired.1697b01c.svg";